import { render, staticRenderFns } from "./SendSMSMobile.vue?vue&type=template&id=127b6ffa&scoped=true&"
import script from "./SendSMSMobile.vue?vue&type=script&lang=js&"
export * from "./SendSMSMobile.vue?vue&type=script&lang=js&"
import style0 from "./SendSMSMobile.vue?vue&type=style&index=0&id=127b6ffa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b6ffa",
  null
  
)

export default component.exports